import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

interface Product3DCardProps {
  product: {
    id: number;
    name: string;
    description: string;
    image: string;
    tags: string[];
  };
  index: number;
}

const Product3DCard = ({ product, index }: Product3DCardProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: 0.06 * index }}
      className="group"
    >
      <Link to="/produits" className="block">
        {/* Image container */}
        <div className="relative overflow-hidden rounded-2xl bg-background border border-border aspect-square">
          <img
            src={product.image}
            alt={product.name}
            className="absolute inset-0 w-full h-full object-contain p-6 md:p-8 group-hover:scale-105 transition-transform duration-700 ease-out"
          />
          {/* Hover overlay */}
          <div className="absolute inset-0 bg-accent/0 group-hover:bg-accent/5 transition-colors duration-500" />
          {/* Arrow */}
          <div className="absolute top-4 right-4 w-10 h-10 rounded-full bg-background/80 backdrop-blur-sm flex items-center justify-center opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-300">
            <ArrowUpRight className="w-5 h-5 text-accent" />
          </div>
        </div>

        {/* Text */}
        <div className="mt-4 space-y-1">
          <h3 className="font-display text-lg font-semibold text-accent group-hover:text-primary transition-colors duration-300">
            {product.name}
          </h3>
          <p className="text-sm text-muted-foreground line-clamp-2">{product.description}</p>
        </div>
      </Link>
    </motion.div>
  );
};

export default Product3DCard;
